import React, { useState, useEffect } from 'react';

// Material
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Drawer from '@material-ui/core/Drawer';

// Types
import { TripInterface } from 'store/ducks/trips/types';

// Components
import { TabPanel } from 'components/TabPanel';
import { InformationNavigation } from './InformationNavigation';

// Styles
import useStyle from './styles';

interface StateProps {
  toggleDrawer(open: boolean): (event: any) => void;
  open: boolean;
  data: TripInterface;
}

type Props = StateProps;

const InfoDrawer: React.FC<Props> = ({ open, data, toggleDrawer }) => {
  const classes = useStyle();
  const [currNavGuide, setCurrNavGuide] = useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setCurrNavGuide(newValue);
  };

  useEffect(() => {
    setCurrNavGuide(0);
  }, [open]);

  return (
    <Drawer anchor='right' onClose={toggleDrawer(false)} open={open}>
      <Tabs
        className={classes.navigationBar}
        indicatorColor='primary'
        onChange={handleChange}
        textColor='primary'
        value={currNavGuide}
        variant='fullWidth'>
        <Tab label='Informações' />
      </Tabs>

      <div className={classes.drawerContents}>
        <TabPanel index={0} value={currNavGuide}>
          <InformationNavigation tripData={data} />
        </TabPanel>
      </div>
    </Drawer>
  );
};

export { InfoDrawer };
export default InfoDrawer;
